// extracted by mini-css-extract-plugin
export var marginNegative = "_60-5 _60-3 _60-1";
export var marginPositive = "_60-4 _60-3 _60-1";
export var modalContent = "_60-6";
export var samplesTable = "_60-8";
export var samplesTableContainer = "_60-7";
export var statBox = "_60-a";
export var tableCell = "_60-1";
export var tableCellCenter = "_60-2 _60-1";
export var tableCellRight = "_60-3 _60-1";
export var tableHeader = "_60-0";
export var trackingNumber = "_60-9";